var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2998 3H3.2998C2.4718 3 1.7998 3.67125 1.7998 4.5V19.5C1.7998 20.3288 2.4718 21 3.2998 21H21.2998C22.1286 21 22.7998 20.3288 22.7998 19.5V4.5C22.7998 3.67125 22.1286 3 21.2998 3ZM21.2998 19.5H3.2998V4.5H21.2998V19.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7998 7.5H10.0498V9H4.7998V7.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7998 10.5H7.7998V12H4.7998V10.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5498 13.5H13.0498C11.8071 13.5 10.7998 14.5073 10.7998 15.75V17.25H12.2998V15.75C12.2998 15.336 12.6358 15 13.0498 15H17.5498C17.9638 15 18.2998 15.336 18.2998 15.75V17.25H19.7998V15.75C19.7998 14.5073 18.7926 13.5 17.5498 13.5Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2998 8.25C16.1286 8.25 16.7998 8.92125 16.7998 9.75C16.7998 10.5788 16.1286 11.25 15.2998 11.25C14.4718 11.25 13.7998 10.5788 13.7998 9.75C13.7998 8.92125 14.4718 8.25 15.2998 8.25ZM15.2998 12.75C16.9566 12.75 18.2998 11.4068 18.2998 9.75C18.2998 8.09325 16.9566 6.75 15.2998 6.75C13.6431 6.75 12.2998 8.09325 12.2998 9.75C12.2998 11.4068 13.6431 12.75 15.2998 12.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactCard);
export default __webpack_public_path__ + "static/media/contact-card.c1baed9fe9b7d23457825b31da291723.svg";
export { ForwardRef as ReactComponent };